import { useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Header from '../../Components/Headers/Header';
import { useEffect } from 'react';
import SideBarPanel from '../../NavBars/SideBarPanel';
import TopBar from '../../NavBars/TopBar';
import styles from './SuppliersList.module.css';
import { getSuppliersFromDB } from './Utilities/getSuppliersFromDB';
import getColumns from './Utilities/getColumns';

// This component shows a table of all suppliers entered into the system
// by the user. The table has key information for each supplier in it.
const SuppliersList = ({ session }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [suppliersData, setSuppliersData] = useState([]);
  const columns = getColumns(colors);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getData() {
      const incomingSuppliersData = await getSuppliersFromDB();
      setSuppliersData(incomingSuppliersData);      
      setLoading(false);
    }
    getData();
  }, []);

  return (
    <>
      <SideBarPanel />
      <main className={styles.supplierslistmain}>
        <nav>
          <TopBar />
        </nav>
        <Box m='20px'>
          <Header
            title='SUPPLIERS'
            subtitle='Listing of Suppliers Added to the System'
          />
          <div className={styles.supplierslisttablewrapper}>
            <Box
              m='40px 0 0 0'
              height='75vh'
              sx={{
                '& .MuiDataGrid-root': {
                  border: 'none',
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: 'none',
                },
                '& .name-column--cell': {
                  color: colors.greenAccent[300],
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: colors.blueAccent[700],
                  borderBottom: 'none',
                },
                '& .MuiDataGrid-virtualScroller': {
                  backgroundColor: colors.primary[400],
                },
                '& .MuiDataGrid-footerContainer': {
                  borderTop: 'none',
                  backgroundColor: colors.blueAccent[700],
                },
                '& .MuiCheckbox-root': {
                  color: `${colors.greenAccent[200]} !important`,
                },
                '& .MuiDataGrid-toolbarContainer .MuiButton-text': {
                  color: `${colors.grey[100]} !important`,
                },
              }}
            >
              <DataGrid
                rows={suppliersData}
                columns={columns}
                loading={loading}
                components={{ Toolbar: GridToolbar }}
                sx={{
                  fontSize: '14px',
                }}
              />
            </Box>
          </div>
        </Box>
      </main>
    </>
  );
};

export default SuppliersList;
